import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../../customer-service.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';
import { PlanCardComponent } from '../../plan-card/plan-card.component';


@Component({
  selector: 'app-manage-businessnetwork',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, PlanCardComponent],
  templateUrl: './manage-businessnetwork.component.html',
  styleUrls: ['./manage-businessnetwork.component.scss', '../../../../../../styles/admin/style.scss',
    '../../../../../../styles/admin/app.scss']
})

export class ManageBusinessnetworkComponent extends FormValidation {

  PLANMAX: number = 0;
  AVAILABLE: number = 0;
  ALLOCATED: number = 0;
  columns: Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  businessData: any;
  prevSearchAfterKey: any;
  stopScroll: boolean = false;
  payload = {
    searchContent: null,
    searchAfterKey: null,
    businessId: null,
    limit: 10,
    statusList: ["ACTIVE", "INACTIVE"],
    type: null
  };
  allocationCards = [
    {
      name: "Plan Max",
      value: null
    },
    {
      name: "Allocated",
      value: null
    },
    {
      name: "Active",
      value: null
    },
  ];

  filerData: any = [
    {
      label: 'Status',
      payload: 'status',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
      ],
    },
    {
      label: 'Network Type',
      payload: 'type',
      options: [
        { value: 'Supplier', label: 'Supplier' },
        { value: 'Client', label: 'Client' },
        // Mutual type. The value sent is the canonical "Client_Supplier";
        // B2BNetworkDao.expandNetworkTypes widens it to every spelling actually
        // stored in the type field ("Client/Supplier" from the Add-Network
        // form, legacy "Customer/Supplier"), so the bucket isn't split by how
        // the row happened to be written.
        { value: 'Client_Supplier', label: 'Client/Supplier' },
      ],
    }
  ]

  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private customerService: CustomerService,
    private pricePlanService: PricePlanService, private util: UtilService) {
    super();
    this.columns = [
      { label: "Network Name", key: "b2bNetworkName", route: true, path: '/user-management/businessNetworks/businessNetworkEdit' },
      { label: "Owner", key: "userName" },
      { label: "Email", key: "email" },
      { label: "Role", key: "role" },
      { label: "Members", key: "membersCount" },

    ];

    this.businessNetworkDetails = {
      networkName: "test",
      owner: "test@gmail.com",
      members: 10
    }



    this._activated_route.parent.data.subscribe(res => {
      this.businessData = res.data;
    });


  }

  ngOnInit(): void {
    this.payload.businessId = this.businessData.id;
    this.getB2BNetworkList();
  }

  getB2BNetworksList(userPayload: Object): Observable<any> {
    return this.API.create('business/findB2BNetworks', userPayload);
  }

  // Display label for the mutual Network Type. `type` is stored as
  // "Client_Supplier" (canonical), "Client/Supplier" (what the Add-Network form
  // writes) or legacy "Customer/Supplier"; all three are the same bucket and
  // must read as one label — otherwise the Client/Supplier filter returns rows
  // whose column says "Client_Supplier". Mirrors the networkTypeLabel pipe used
  // by the Business Networks listing and manage-business-contact's
  // formatBusinessType.
  private formatNetworkType(type: string): string {
    if (!type) { return type; }
    const normalized = type.trim().toLowerCase();
    return (normalized === 'client_supplier'
         || normalized === 'client/supplier'
         || normalized === 'customer/supplier'
         || normalized === 'customer_supplier')
      ? 'Client/Supplier'
      : type;
  }
  activeCount:number;
  getB2BNetworkList() {
    this.util.startLoader();
    this.getB2BNetworksList(this.payload).subscribe(response => {
      this.util.stopLoader();
      if (response.code === GigsumoConstants.SUCESSCODE) {
        if(response?.data?.activeCount && this.payload.searchAfterKey==null || response?.data?.activeCount==0 && this.payload.searchAfterKey==null){
          this.activeCount= response?.data?.activeCount;
        }
        const searchKey = response.data.searchAfterKey;
        let networks = response.data.b2bNetworks;
        networks.forEach(network => {

          network.type = this.formatNetworkType(network.type);

          if (network.userData) {
            network.userName = `${network.userData.firstName} ${network.userData.lastName}`;
            network.email = network.userData.email;
            network.role = "Super Admin";
          }
        });
        if (networks) {
          const current = networks;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist, ...current]);
        }

        if (networks != null && (networks.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))) {
          this.stopScroll = true;
        }
        this.prevSearchAfterKey = searchKey;
        let plan = response.data.businessPlanUsage;
        let found = (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'B2B_NETWORKS'));
        if (found) {
          this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
          this.AVAILABLE = this.activeCount ;
          this.ALLOCATED = found.utilized;
          this.allocationCards[0].value = this.PLANMAX;
          this.allocationCards[1].value = this.ALLOCATED;
        }
        this.allocationCards[2].value = response.data.activeCount;

      }
    });
  }

  updateBusinessNetwork(event) {
  }


  async updateContactMembers(members) {
    const userData = members.value;
    const updatedData = JSON.parse(JSON.stringify(this.userDatas.getValue()));

    if (members.checked) {
      this.util.startLoader();
      const plan = await this.customerService.getBusinessPLanBenefits(this.businessData.id, "B2B_NETWORKS");
      if (plan.available > 0) {
        this.updateMembersBulk(userData);
      }
      else {

        updatedData.forEach(res => {
          if (res.b2bNetworkId === userData.b2bNetworkId) {
            res.status = "INACTIVE";
          }
        });
        this.userDatas.next(updatedData);
        this.util.stopLoader();

        this.pricePlanService.expiredPopup(
          "B2B_NETWORKS",
          "PAY",
          null,
          null,
          null,
          null,
          plan.available,
          plan.actual,
          plan.utilized,
          plan.promotional
        );
        this.util.stopLoader();
      }


    }
    else if (!members.checked) {
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title: "Inactive Business Network",
        allowOutsideClick: false,
        text: `Are you sure you want to inactive ${userData.b2bNetworkName} ?`
      }).then(res => {
        this.util.startLoader();

        if (res.isConfirmed) {
          this.updateMembersBulk(userData);
          this.util.stopLoader();
        }
        else {
          updatedData.forEach(res => {
            if (res.b2bNetworkId === userData.b2bNetworkId) {
              res.status = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }


      });
    }

  }


  updateMembersBulk(data) {
    this.API.create("business/editB2BNetwork", data).subscribe(response => {
      if (response.code === GigsumoConstants.SUCESSCODE) {
        Swal.fire({
          icon: "success",
          title: 'Business Network Updated!',
          text: 'Business network updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getB2BNetworkList();
        }, 2000);
        this.util.stopLoader();
      }
    });
  }


  async getBusinessPLanBenefits() {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    if (plan) {
      return plan.find(x => x.benefitKey === "B2B_NETWORKS");
    }
  }


  onSearch(value, obj: ManageBusinessnetworkComponent) {
    console.log(value);
    console.log("value");

    obj.payload = {
      ...obj.payload,
      searchContent: value,
      searchAfterKey: null,
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getB2BNetworkList();
  }

  onFilter(data, obj: ManageBusinessnetworkComponent) {
    console.log(data);
    console.log("data");
    obj.payload = {
      ...obj.payload,
      statusList: data.status != null ? [data.status] : ["ACTIVE", "INACTIVE"],
      type: data.type != null ? data.type : null,
      searchAfterKey: null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getB2BNetworkList();
  }

  onScroll(obj: ManageBusinessnetworkComponent) {
    if (!this.stopScroll) {
      obj.payload = {
        ...obj.payload,
        searchAfterKey: obj.prevSearchAfterKey
      };
      obj.getB2BNetworkList();
    }
  }
}
